import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { Box, HStack, Text, VStack, useDisclose } from "native-base";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import es from "react-phone-number-input/locale/es.json";
import styles from "./styles.module.css";
import Modal from "../modal";
import colors from "../../constants/colors";
import { source } from "../../api";

function RegistrationModal(props) {
  const { isOpen, onRequestClose, onRegister, onLogin, isLoading } = props;
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const { isOpen: isSignIn, onToggle: onToggleSignIn } = useDisclose();

  useEffect(() => {
    setEmail("");
    setPassword("");
  }, [isSignIn]);

  return (
    <Modal isOpen={isOpen} onRequestClose={onRequestClose} maxWidth={700}>
      <form
        className={styles.form}
        onSubmit={(e) => {
          e.preventDefault();
          if (isSignIn) {
            onLogin({
              identifier: email,
              password,
            });
          } else {
            if (isValidPhoneNumber(phone)) {
              onRegister({
                username: email,
                email,
                password,
                firstName,
                lastName,
                phone,
                confirmPassword,
                source,
              });
            }
          }
        }}
        autoComplete="off">
        <VStack paddingX={10} paddingY={5} space={5}>
          {isSignIn ? (
            <>
              <Text>Inicio de sesión</Text>
              <label className={styles.input}>
                <Text>Correo electrónico</Text>
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                  disabled={isLoading}
                />
              </label>
              <label className={styles.input}>
                <Text>Contraseña</Text>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  disabled={isLoading}
                />
              </label>
            </>
          ) : (
            <>
              <Text>Para continuar, por favor déjanos tus datos.</Text>
              <HStack space={5}>
                <label className={styles.input}>
                  <Text>Nombre</Text>
                  <input
                    type="text"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </label>
                <label className={styles.input}>
                  <Text>Apellido</Text>
                  <input
                    type="text"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                    required
                    disabled={isLoading}
                  />
                </label>
              </HStack>
              <HStack space={5}>
                <label className={styles.input}>
                  <Text>Número de teléfono</Text>
                  <PhoneInput
                    labels={es}
                    defaultCountry="MX"
                    disabled={isLoading}
                    value={phone}
                    onChange={(text) => setPhone(text || "")}
                    required
                    limitMaxLength
                    numberInputProps={{
                      pattern: isValidPhoneNumber(phone) ? undefined : "@",
                    }}
                  />
                  {phone && !isValidPhoneNumber(phone) && (
                    <Text
                      position="absolute"
                      fontSize="xs"
                      bottom={-16}
                      lineHeight={12}
                      color={colors.primary}>
                      Número de teléfono invalido
                    </Text>
                  )}
                </label>
                <label className={styles.input}>
                  <Text>Correo electrónico</Text>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                    disabled={isLoading}
                    autoComplete="new-password"
                  />
                </label>
              </HStack>
              <HStack space={5}>
                <label className={styles.input}>
                  <Text>Contraseña</Text>
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    disabled={isLoading}
                    autoComplete="new-password"
                  />
                </label>
                <label className={styles.input}>
                  <Text>Confirmar contraseña</Text>
                  <input
                    type="password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                    disabled={isLoading}
                    autoComplete="new-password"
                  />
                </label>
              </HStack>
            </>
          )}
          <button disabled={isLoading}>
            <Box
              backgroundColor={colors.primary}
              paddingX={20}
              paddingY={2}
              borderRadius="full">
              <Text color={colors.white}>
                {isSignIn ? "Iniciar sesión" : "Continuar"}
              </Text>
            </Box>
          </button>
          <HStack width="full" space={5}>
            <Box flex={1} backgroundColor={colors.lightGray} height="1px" />
            <Text>O</Text>
            <Box flex={1} backgroundColor={colors.lightGray} height="1px" />
          </HStack>
          <button disabled={isLoading} type="button" onClick={onToggleSignIn}>
            <Box paddingX={20} paddingY={2} borderRadius="full">
              <Text>{isSignIn ? "Regístrate" : "Inicia sesión"}</Text>
            </Box>
          </button>
        </VStack>
      </form>
    </Modal>
  );
}

RegistrationModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onRequestClose: PropTypes.func.isRequired,
  onRegister: PropTypes.func.isRequired,
  onLogin: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default React.memo(RegistrationModal);
